module.exports = __webpack_public_path__ + "static/media/7.39b638fe.png";